import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UUID } from 'angular2-uuid';
import { WINDmodel } from '../../shared/classes/windModel';
import { Activity } from '../../shared/classes/activityModel';
import { Practice } from '../../shared/classes/practiceModel';
import { POP } from '../../shared/classes/popModel';
import { AuthenticateService } from '../../shared/services/authenticate.service'
const now = new Date();
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import { CognitoService } from 'src/app/shared/services/cognito.service';
import { FileUploadService } from 'src/app/shared/services/fileupload.service';
import { ProfileService } from 'src/app/shared/services/profile.service';
import { TokenStorageService } from 'src/app/shared/services/token.service';
@Component({
  selector: 'app-pop-data',
  templateUrl: './pop-data.component.html',
  styleUrls: ['./pop-data.component.sass']
})
export class PopDataComponent implements OnInit {

  @Input() fetchedToolList;
  @Input() index;
  @Input() finalBtntype;
  @Input() profileUuid;
  @Input() mainprofileArray;
  groupName = this.tokenService.getGroup();
  globalImgUrl = this.authService.s3url();
  insectArray: any = [];
  diseaseArray: any = [];
  weedArray: any = [];
  nutritionArray: any = [];
  activityArray: any = [];
  practiceArray: any = [];
  pop: POP[];
  showIList: boolean = true;
  showDList: boolean = true;
  showWList: boolean = true;
  showNList: boolean = true;
  showAList: boolean = true;
  showPList: boolean = true;
  showHList: boolean = true;
  popIndex: number;
  popId: string;
  insectText: boolean = false;
  diseaseText: boolean = false;
  weedText: boolean = false;
  nutritionText: boolean = false;
  insectInstruction: string = '';
  diseaseInstruction: string = '';
  weedInstruction: string = '';
  nutritionInstruction: string = '';
  productList: any = [];
  videoUrl: string = '';
  videoName: string = '';
  urls = [];
  poptype: string = 'save';
  windGroup: FormGroup;
  imageNameList = [];
  popApplication: string = '';
  popProduct: string = '';
  popDosage: string = '';
  popPractice: string = '';
  sobj: {};
  wind: WINDmodel;
  practice: Practice;
  activity: Activity;
  tempObject: any;
  uploadFileList: any[] = [];
  iobj: { product: string; application: string; dosage: string; info: string; image: any[]; video: string };
  dobj: { product: string; application: string; dosage: string; info: string; image: any[]; video: string };
  wobj: { product: string; application: string; dosage: string; info: string; image: any[]; video: string };
  nobj: { product: string; application: string; dosage: string; info: string; image: any[]; video: string };
  aobj: { application: string; image: any[]; video: string };
  pobj: { practice: string; image: any[]; video: string };
  videoArray = [];
  videoList = [];
  insectImgList = [];
  diseaseImgList = [];
  weedImgList = [];
  nutritionImgList = [];
  activityImgList = [];
  practiceImgList = [];
  imageUploadService: string;
  popindex: number;
  // profileUuid: string = '';

  constructor(private _formBuilder: FormBuilder,
    private authService: AuthenticateService,
    private profileService: ProfileService,
    private cognitoService: CognitoService,
    private tokenService : TokenStorageService,
    private fileUploadService:FileUploadService
    ) { }

  ngOnInit() {
    this.getAllProducts();
    this.profileService.savePopData.subscribe((data) => {
      console.log("savePop");
      this.savePop();
    })
  }

  ngOnChanges() {
    this.pop = [];
    this.getAllProducts();
    this.openPopData(this.index);
    this.windGroup = this._formBuilder.group({
      product: ['', Validators.required],
      dosage: ['', Validators.required],
      application: ['', Validators.required],
    });
  }
  config = {
    displayKey: 'productName', // if objects array passed which key to be displayed defaults to description
    search: true,
    limitTo: 100,
    height: '225px'
  };

  handleInput(e) {
    if (e.which === 32 && e.target.selectionStart === 0) {
      return false;
    }
  }

  onImgError(event) {
    event.target.src = this.globalImgUrl + 'agri_logo.png';
  }

  openPopData(index) {
    console.log("this.pop ", this.pop[index], index);
    this.popId = undefined;
    this.insectArray = [];
    this.showIList = true;
    this.diseaseArray = [];
    this.weedArray = [];
    this.nutritionArray = [];
    this.activityArray = [];
    this.practiceArray = [];
    this.insectInstruction = '';
    this.diseaseInstruction = '';
    this.weedInstruction = '';
    this.nutritionInstruction = '';
    this.insectText = false;
    this.diseaseText = false;
    this.weedText = false;
    this.nutritionText = false;
    console.log("crop data index ", this.fetchedToolList);
    this.popIndex = index;

    if (this.fetchedToolList.length == 0) {
      this.popId = undefined;
    } else {
      // if (this.fetchedToolList[0].collectionData.length > index) {
      if (this.mainprofileArray[index].popId && this.mainprofileArray[index].popId != '') {
        console.log("INDEX ", this.mainprofileArray[index])
        this.getPOPfromTool(this.mainprofileArray[index]);
      } else {
        this.popId = undefined;
      }
    }
  }

  getPOPfromTool(fetchedData) {
    var obj = {
      popId: fetchedData.popId,
      group: this.groupName
    }
    console.log("popObj", obj)
    this.profileService.getAllPOP(obj).then((data: any) => {
      console.log("getAllPOP == ", data);
      console.log("getAllPOP  this.pop == ", this.pop);
      if (data.length > 0) {
        const indexOfPop = this.pop.map(e => e.popId).indexOf(data[0].popId);
        console.log("index of pop ", indexOfPop);
        this.popId = data[0].popId;
        console.log("this.popId ", this.popId);
        this.insectArray = data[0].insect.solution;
        console.log("this.insectArray", this.insectArray)
        this.insectInstruction = data[0].insect.instruction;
        this.diseaseInstruction = data[0].disease.instruction;
        this.weedInstruction = data[0].weed.instruction;
        this.nutritionInstruction = data[0].nutrition.instruction;
        // this.insectInstruction = data[0].insect.instruction
        this.diseaseArray = data[0].disease.solution;
        // this.diseaseInstruction = data[0].disease.instruction
        this.weedArray = data[0].weed.solution;
        // this.weedInstruction = data[0].weed.instruction
        this.nutritionArray = data[0].nutrition.solution;
        // this.nutritionInstruction = data[0].nutrition.instruction
        this.activityArray = data[0].activity;
        this.practiceArray = data[0].practice;
        // }
      } else {
        const indexOfPop = this.pop.map(e => e.popId).indexOf(fetchedData.popId);
        console.log("local index of pop ", fetchedData.popId, indexOfPop);
        if (indexOfPop != -1) {
          this.popId = this.pop[indexOfPop].popId;
          console.log("local this.popId ", this.popId);
          this.insectArray = this.pop[indexOfPop].insect.solution;
          this.insectInstruction = this.pop[indexOfPop].insect.instruction;
          this.diseaseInstruction = this.pop[indexOfPop].disease.instruction;
          this.weedInstruction = this.pop[indexOfPop].weed.instruction;
          this.nutritionInstruction = this.pop[indexOfPop].nutrition.instruction;
          // this.insectInstruction = this.pop[index].insect.instruction
          this.diseaseArray = this.pop[indexOfPop].disease.solution;
          // this.diseaseInstruction = this.pop[index].disease.instruction
          this.weedArray = this.pop[indexOfPop].weed.solution;
          // this.weedInstruction = this.pop[index].weed.instruction
          this.nutritionArray = this.pop[indexOfPop].nutrition.solution;
          // this.nutritionInstruction = this.pop[index].nutrition.instruction
          this.activityArray = this.pop[indexOfPop].activity;
          this.practiceArray = this.pop[indexOfPop].practice;
        }
      }
    })
  }

  addPOP(type) {
    console.log("ADD POP TYPE : ", type);
    this.popProduct = '';
    this.popApplication = '';
    this.popDosage = '';
    this.popPractice = '';
    this.poptype = 'save';
    this.imageNameList = [];
    this.urls = [];
    this.videoName = '';
    this.videoUrl = '';
    if (type == 'insect') {
      console.log("insectArray ", this.insectArray);
      this.showIList = false;
      this.iobj = { product: '', application: '', dosage: '', info: '', image: [], video: '' };
      this.windGroup.reset();
    } else if (type == 'disease') {
      this.showDList = false;
      this.dobj = { product: '', application: '', dosage: '', info: '', image: [], video: '' };
      this.windGroup.reset();
    } else if (type == 'weed') {
      this.showWList = false;
      this.wobj = { product: '', application: '', dosage: '', info: '', image: [], video: '' };
      this.windGroup.reset();
    } else if (type == 'nutrition') {
      this.showNList = false;
      this.nobj = { product: '', application: '', dosage: '', info: '', image: [], video: '' };
      this.windGroup.reset();
    } else if (type == 'activity') {
      this.showAList = false;
      this.aobj = { application: '', image: [], video: '' }
    } else if (type == 'practice') {
      this.showPList = false;
      this.pobj = { practice: '', image: [], video: '' }
    }
  }
  addInsect() {
    this.poptype = 'save';
    this.showIList = false;
    this.iobj = { product: '', application: '', dosage: '', info: '', image: [], video: '' };
    this.windGroup.reset();
  }

  adddisease() {
    this.poptype = 'save'
    this.showDList = false;
    this.dobj = { product: '', application: '', dosage: '', info: '', image: [], video: '' };
    this.windGroup.reset();
  }

  addWeed() {
    this.poptype = 'save'
    this.showWList = false;
    this.wobj = { product: '', application: '', dosage: '', info: '', image: [], video: '' };
    this.windGroup.reset();
  }

  addNutrition() {
    this.poptype = 'save'
    this.showNList = false;
    this.nobj = { product: '', application: '', dosage: '', info: '', image: [], video: '' };
    this.windGroup.reset();
  }

  addActivity() {
    this.poptype = 'save'
    this.showAList = false;
    this.aobj = { application: '', image: [], video: '' }
  }

  addPractice() {
    this.poptype = 'save'
    this.showPList = false;
    this.pobj = { practice: '', image: [], video: '' }
  }

  onchangetab(event) {
    console.log("event ", event.index)
    this.showIList = true;
    this.showDList = true;
    this.showNList = true;
    this.showAList = true;
    this.showPList = true;
    this.showWList = true;
    this.getAllProducts();
    this.urls = [];
    this.videoUrl = '';
    this.videoName = '';
    this.windGroup.reset();
    this.poptype = 'save'
  }

  getAllProducts() {
    this.productList = [];
    let obj = {
      group: this.groupName
  }
    this.profileService.getAllProducts(obj).then((data: any) => {
      console.log("getAllProducts ", data);
      if (data.length > 0) {
        for (var i = 0; i < data.length; i++) {
          this.productList.push(data[i].tradeName);
        }
        console.log("productList ", this.productList);
      } else {
        Swal.fire(
          'Error',
          'Products not found',
          'error'
        )
      }

    })
  }

  editInstruction(type) {
    if (type == 'insect') {
      this.insectText = false
    }
    else if (type == 'disease') {
      this.diseaseText = false;
    }
    else if (type == 'weed') {
      this.weedText = false;
    }
    else if (type == 'nutrition') {
      this.nutritionText = false;
    }
  }

  back(type) {
    console.log("this.tempObject ", this.tempObject)
    if (type == 'insect') {
      this.iobj = Object.assign({}, this.tempObject);
      console.log("this.iobj ", this.iobj)
      this.showIList = true;
    }
    else if (type == 'disease') {
      this.showDList = true;
      this.dobj = this.tempObject;
    }
    else if (type == 'nutrition') {
      this.showNList = true;
      this.nobj = this.tempObject;
    }
    else if (type == 'weed') {
      this.showWList = true;
      this.wobj = this.tempObject;
    }
    else if (type == 'activity') {
      this.showAList = true;
      this.aobj = this.tempObject;
    }
    else if (type == 'practice') {
      this.showPList = true;
      this.pobj = this.tempObject;
    }
    this.windGroup.reset();
  }

  saveInsect() {
    this.showIList = true;
    console.log("this.imageNameList : ", this.iobj, this.imageNameList);
    this.iobj.image = this.imageNameList;
    this.iobj.video = this.videoName;
    this.iobj.product = this.popProduct;
    this.iobj.application = this.popApplication;
    this.iobj.dosage = this.popDosage;
    this.wind = this.iobj;
    this.insectArray.push(this.wind);
    console.log("insectArray", this.insectArray);
    this.imageNameList = [];
    this.urls = [];
    this.videoName = '';
    this.videoUrl = '';
    this.uploadFileToActivity()
    this.windGroup.reset();
  }

  savedisease() {
    this.showDList = true;
    this.dobj.image = this.imageNameList;
    this.dobj.video = this.videoName;
    this.dobj.product = this.popProduct;
    this.dobj.application = this.popApplication;
    this.dobj.dosage = this.popDosage;
    this.wind = this.dobj;
    this.diseaseArray.push(this.wind);
    this.urls = [];
    this.imageNameList = [];
    this.videoUrl = '';
    this.videoName = '';
    this.uploadFileToActivity()
    this.windGroup.reset();
  }

  saveWeed() {
    this.showWList = true;
    this.wobj.image = this.imageNameList;
    this.wobj.video = this.videoName;
    this.wobj.product = this.popProduct;
    this.wobj.application = this.popApplication;
    this.wobj.dosage = this.popDosage;
    this.wind = this.wobj;
    this.weedArray.push(this.wind);
    this.urls = [];
    this.imageNameList = [];
    this.videoUrl = '';
    this.videoName = '';
    this.uploadFileToActivity()
    this.windGroup.reset();
  }

  saveNutrition() {
    this.showNList = true;
    this.nobj.image = this.imageNameList;
    this.nobj.video = this.videoName;
    this.nobj.product = this.popProduct;
    this.nobj.application = this.popApplication;
    this.nobj.dosage = this.popDosage;
    this.wind = this.nobj;
    this.nutritionArray.push(this.wind);
    this.urls = [];
    this.imageNameList = [];
    this.videoUrl = '';
    this.videoName = '';
    this.uploadFileToActivity()
    this.windGroup.reset();
  }

  saveActivity() {
    this.showAList = true;
    this.aobj.image = this.imageNameList;
    this.aobj.video = this.videoName;
    this.aobj.application = this.popApplication;
    this.activity = this.aobj;
    this.activityArray.push(this.activity);
    this.urls = [];
    this.imageNameList = [];
    this.videoName = '';
    this.videoUrl = '';
    this.uploadFileToActivity()
    this.windGroup.reset();
  }

  savePractice() {
    this.showPList = true;
    this.pobj.image = this.imageNameList;
    this.pobj.video = this.videoName;
    this.pobj.practice = this.popPractice;
    this.practice = this.pobj;
    this.practiceArray.push(this.practice);
    this.urls = [];
    this.imageNameList = [];
    this.videoUrl = '';
    this.videoName = '';
    this.uploadFileToActivity()
    this.windGroup.reset();
  }

  imageInput(event, type) {
    console.log("type : ", type);
    if (event.target.files && event.target.files[0]) {
      var fileLength = event.target.files.length
      for (let i = 0; i < fileLength; i++) {
        if (event.target.files[i].type.split('/')[0] == 'image') {
          var reader = new FileReader();
          reader.onload = (event: any) => {
            this.urls.push(event.target.result);
            if (type == 'insect') {
              this.insectImgList.push(event.target.result);
            } else if (type == 'disease') {
              this.diseaseImgList.push(event.target.result);
            } else if (type == 'weed') {
              this.weedImgList.push(event.target.result);
            } else if (type == 'nutrition') {
              this.nutritionImgList.push(event.target.result);
            } else if (type == 'activity') {
              this.activityImgList.push(event.target.result);
            } else if (type == 'practice') {
              this.practiceImgList.push(event.target.result);
            }
          }
          reader.readAsDataURL(event.target.files[i]);
          let iuuid = UUID.UUID();
          this.imageUploadService = type + '_' + iuuid + "." + event.target.files.item(0).type.split('/')[1];
          this.imageNameList.push(this.imageUploadService);

          const formData: FormData = new FormData();
          formData.set('file', event.target.files[i], this.imageUploadService);
          formData.append('name',this.imageUploadService)
          this.uploadFileList.push(formData)
        }
      }
    }

  }

  videoInput(event, type) {
    this.videoUrl = '';
    this.videoName = '';
    if (event.target.files && event.target.files[0]) {
      if (event.target.files[0].type.split('/')[0] == 'video') {
        var fileLength = event.target.files.length
        var reader = new FileReader()
        reader.onload = (event: any) => {
          this.videoUrl = event.target.result;
        }
        reader.readAsDataURL(event.target.files[0]);
        let iuuid = UUID.UUID();
        this.videoName = type + '_' + iuuid + "." + event.target.files.item(0).type.split('/')[1];
        this.videoList.push(this.videoName);
        const formData: FormData = new FormData();
        formData.set('file', event.target.files[0], this.videoName);
        formData.append('name',this.videoName)
        this.videoArray.push(formData);
      }
    }
  }
  uploadFileToActivity() {
    for (var i = 0; i < this.uploadFileList.length; i++) {
      this.fileUploadService.uploadMultipleFiles(this.uploadFileList[i],this.imageUploadService)
    }
  }
  uploadVideo() {
    for (var i = 0; i < this.videoArray.length; i++) {
      this.fileUploadService.uploadMultipleFiles(this.videoArray[i],this.videoName)
    }
  }

  deleteImage(index) {
    this.imageNameList.splice(index, 1);
    this.urls.splice(index, 1);
    if (this.uploadFileList.length > 0) {
      this.uploadFileList.splice(index, 1);
    }
    console.log("deleteImage ", this.imageNameList);
  }

  editPOP(type, index) {
    this.tempObject = {};
    this.poptype = 'update'
    this.urls = [];
    this.imageNameList = [];
    this.videoUrl = '';
    this.videoName = '';
    this.popindex = index
    console.log("edit data ", type);
    this.popProduct = '';
    this.popApplication = '';
    this.popDosage = '';
    this.popPractice = ''
    if (type == 'insect') {
      this.imageNameList = this.insectArray[index].image;
      for (var i = 0; i < this.insectArray[index].image.length; i++) {
        console.log("images : ", this.insectArray[index].image[i])
        this.urls.push(this.globalImgUrl + this.insectArray[index].image[i]);
        console.log("urls : ", this.urls)
      }
      if (this.insectArray[index].video != '')
        this.videoUrl = this.globalImgUrl + this.insectArray[index].video
      else this.videoUrl = '';
      this.videoName = this.insectArray[index].video;

      this.iobj = this.insectArray[index];
      this.popProduct = this.iobj.product;
      this.popApplication = this.iobj.application;
      this.popDosage = this.iobj.dosage;
      this.tempObject = Object.assign({}, this.insectArray[index]);
      this.showIList = false;
    } else if (type == 'disease') {
      this.imageNameList = this.diseaseArray[index].image;
      for (var i = 0; i < this.diseaseArray[index].image.length; i++) {
        this.urls.push(this.globalImgUrl + this.diseaseArray[index].image[i]);
      }
      this.videoName = this.diseaseArray[index].video
      if (this.diseaseArray[index].video != '')
        this.videoUrl = this.globalImgUrl + this.diseaseArray[index].video
      else this.videoUrl = '';
      this.dobj = this.diseaseArray[index];
      this.popProduct = this.dobj.product;
      this.popApplication = this.dobj.application;
      this.popDosage = this.dobj.dosage;
      this.tempObject = Object.assign({}, this.diseaseArray[index]);
      this.showDList = false;
    } else if (type == 'weed') {
      this.imageNameList = this.weedArray[index].image;
      for (var i = 0; i < this.weedArray[index].image.length; i++) {
        this.urls.push(this.globalImgUrl + this.weedArray[index].image[i]);
      }
      this.videoName = this.weedArray[index].video
      if (this.weedArray[index].video != '')
        this.videoUrl = this.globalImgUrl + this.weedArray[index].video
      else this.videoUrl = '';
      this.wobj = this.weedArray[index];
      this.popProduct = this.wobj.product;
      this.popApplication = this.wobj.application;
      this.popDosage = this.wobj.dosage;
      this.tempObject = Object.assign({}, this.weedArray[index]);
      this.showWList = false;
    } else if (type == 'nutrition') {
      this.imageNameList = this.nutritionArray[index].image;
      for (var i = 0; i < this.nutritionArray[index].image.length; i++) {
        this.urls.push(this.globalImgUrl + this.nutritionArray[index].image[i]);
      }
      this.videoName = this.nutritionArray[index].video ? this.nutritionArray[index].video : ''
      if (this.nutritionArray[index].video != '')
        this.videoUrl = this.globalImgUrl + this.nutritionArray[index].video
      else this.videoUrl = '';
      this.nobj = this.nutritionArray[index];
      this.popProduct = this.nobj.product;
      this.popApplication = this.nobj.application;
      this.popDosage = this.nobj.dosage;
      this.tempObject = Object.assign({}, this.nutritionArray[index]);
      this.showNList = false;
    } else if (type == 'activity') {
      this.imageNameList = this.activityArray[index].image;
      for (var i = 0; i < this.activityArray[index].image.length; i++) {
        this.urls.push(this.globalImgUrl + this.activityArray[index].image[i]);
      }
      this.videoName = this.activityArray[index].video
      if (this.activityArray[index].video != '')
        this.videoUrl = this.globalImgUrl + this.activityArray[index].video
      else this.videoUrl = '';
      this.aobj = this.activityArray[index];
      this.popApplication = this.activityArray[index].application
      this.tempObject = Object.assign({}, this.activityArray[index]);
      this.showAList = false;
    } else if (type == 'practice') {
      this.imageNameList = this.practiceArray[index].image;
      for (var i = 0; i < this.practiceArray[index].image.length; i++) {
        this.urls.push(this.globalImgUrl + this.practiceArray[index].image[i]);
      }
      this.videoName = this.practiceArray[index].video
      if (this.practiceArray[index].video != '')
        this.videoUrl = this.globalImgUrl + this.practiceArray[index].video
      else this.videoUrl = '';
      this.pobj = this.practiceArray[index];
      this.popPractice = this.practiceArray[index].practice;
      this.tempObject = Object.assign({}, this.practiceArray[index]);
      this.showPList = false;
    }
  }

  deleteVideo() {
    this.videoUrl = '';
    this.videoName = '';
  }

  deletePOP(type, index) {
    console.log("deletePoP:-", type, index, this.insectArray[index])
    if (type == 'insect') {
      this.insectArray.splice(index, 1)
    } else if ((type == 'disease')) {
      this.diseaseArray.splice(index, 1)
    } else if ((type == 'weed')) {
      this.weedArray.splice(index, 1)
    } else if ((type == 'nutrition')) {
      this.nutritionArray.splice(index, 1)
    } else if ((type == 'activity')) {
      this.activityArray.splice(index, 1)
    } else if ((type == 'practice')) {
      this.practiceArray.splice(index, 1)
    }
  }

  updatePOP(type) {
    this.poptype = 'save'
    console.log("updatePOP ", this.iobj)
    if (type == 'insect') {
      this.iobj.application = this.popApplication
      this.iobj.dosage = this.popDosage
      this.iobj.info = this.insectInstruction
      this.iobj.product = this.popProduct
      this.iobj.image = this.iobj.image.concat(this.imageNameList.filter((item) => {
        return this.iobj.image.indexOf(item) < 0;
      }));
      this.iobj.video = this.videoName;
      this.insectArray[this.popindex] = this.iobj;
      this.showIList = true;
    } else if (type == 'disease') {
      this.dobj.application = this.popApplication
      this.dobj.dosage = this.popDosage
      this.dobj.info = this.insectInstruction
      this.dobj.product = this.popProduct
      this.dobj.image = this.dobj.image.concat(this.imageNameList.filter((item) => {
        return this.dobj.image.indexOf(item) < 0;
      }));
      this.dobj.video = this.videoName;
      this.diseaseArray[this.popindex] = this.dobj;
      this.showDList = true;
    } else if (type == 'weed') {
      this.wobj.application = this.popApplication
      this.wobj.dosage = this.popDosage
      this.wobj.info = this.insectInstruction
      this.wobj.product = this.popProduct
      this.wobj.image = this.wobj.image.concat(this.imageNameList.filter((item) => {
        return this.wobj.image.indexOf(item) < 0;
      }));
      this.wobj.video = this.videoName;
      this.weedArray[this.popindex] = this.wobj;
      this.showWList = true;
    } else if (type == 'nutrition') {
      this.nobj.application = this.popApplication
      this.nobj.dosage = this.popDosage
      this.nobj.info = this.insectInstruction
      this.nobj.product = this.popProduct
      this.nobj.image = this.nobj.image.concat(this.imageNameList.filter((item) => {
        return this.nobj.image.indexOf(item) < 0;
      }));
      this.nobj.video = this.videoName;
      this.nutritionArray[this.popindex] = this.nobj;
      this.showNList = true;
    } else if (type == 'activity') {
      this.aobj.application = this.popApplication
      this.aobj.image = this.aobj.image.concat(this.imageNameList.filter((item) => {
        return this.aobj.image.indexOf(item) < 0;
      }));
      this.aobj.video = this.videoName;
      this.activityArray[this.popindex] = this.aobj;
      this.showAList = true;
    } else if (type == 'practice') {
      this.pobj.practice = this.popPractice
      this.pobj.image = this.pobj.image.concat(this.imageNameList.filter((item) => {
        return this.pobj.image.indexOf(item) < 0;
      }));
      this.pobj.video = this.videoName;
      this.practiceArray[this.popindex] = this.pobj;
      this.showPList = true;
    }
    this.uploadFileToActivity()
    this.windGroup.reset();
  }

  addInstruction(type) {
    if (type == 'insect') {
      this.insectText = true
    }
    else if (type == 'disease') {
      this.diseaseText = true;
    }
    else if (type == 'weed') {
      this.weedText = true;
    }
    else if (type == 'nutrition') {
      this.nutritionText = true;
    }
  }

  savePop() {
    console.log("this.insectArray", this.insectArray);
    this.showIList = true;
    console.log("savePOP this.popId ", this.popId)
    if (this.popId == undefined) {
      this.popId = UUID.UUID();
    }
    let pop = {
      popId: this.popId,
      profileId: this.profileUuid,
      group: this.groupName,
      insect: {
        instruction: this.insectInstruction,
        solution: this.insectArray
      },
      disease: {
        instruction: this.diseaseInstruction,
        solution: this.diseaseArray
      },
      weed: {
        instruction: this.weedInstruction,
        solution: this.weedArray
      },
      nutrition: {
        instruction: this.nutritionInstruction,
        solution: this.nutritionArray
      },
      activity: this.activityArray,
      practice: this.practiceArray
    };
    console.log("pop", pop);
    const found = this.pop.some(el => el.popId === this.popId);
    console.log("found ", found);
    if (!found) {
      this.pop.push(pop)
    } else {
      console.log("this.newpop ", JSON.stringify(pop))
    }
    if (this.finalBtntype != 'save') {
      // this.updatePOPData(pop);
      this.profileService.updatePOP(pop).then((data: any) => {
        let sendPop = {};
        sendPop['popId'] = this.popId;
        sendPop['popIndex'] = this.popIndex;
        sendPop['popData'] = this.pop;
        this.insectArray = [];
        this.profileService.sendPopData(sendPop);
      })
    }
  }

  // updatePOPData(pop) {
  //   this.toolService.updatePOP(pop).then((data: any) => {
  //     console.log("pop data", data);
  //     let sendPop = {};
  //     sendPop['popId'] = this.popId;
  //     sendPop['popIndex'] = this.popIndex;
  //     sendPop['popData'] = this.pop;
  //     this.insectArray = [];
  //     this.toolService.sendPopData(sendPop);
  //   })
  // }

}
